const ONE_TIME = {
  OPTION_ONE: "Email",
  FORM_SUBMIT: "Submit",
  INVALID_PHONE_TOOLTIP: "Invalid phone number entered!",
  INVALID_EMAIL_TOOLTIP: "Invalid email entered!",
  DISABLE_TOOLTIP: "Filling the selected field is mandatory!",
  RETURN_BUTTON: "Back",
  IMPORT_CODE_PLACEHOLDER: "Enter the code...",
  ENTER_TO_RAYCHAT: "Enter Raychat",
  IMPORT_CODE_TOOLTIP: "The entered code must be 4 digits!",
  PAGE_TITLE: "Login With One Time Verification Code!",
  FORM_DESC: `First, select one of the options below, then enter the email address or phone number you used during registration. The otp will be sent to you.`,
  IMPORT_CODE_DESC: "Enter the code sent to your email or phone number.",
  WITH_COUNTRY_MOBILE_PLACEHOLDER: "Mobile",
};

export default ONE_TIME;
